import React from 'react';
import './TagSelector.scss';

class TagSelector extends React.Component {
  constructor(props) {
    super();
    this.handleCheck = this.handleCheck.bind(this);
    this.state = {
        checked: false
    }
  }

  handleCheck = async (event) => {
    var tag = JSON.parse(JSON.stringify(this.props.item));

    if (tag.Status === 'Available') {
        if (this.props.selections[tag.ChildNumber]) {
            this.props.selections[tag.ChildNumber] = null;
        }
        else {
            this.props.selections[tag.ChildNumber] = tag;
        }
    }
  }

  render() {
    var tag = JSON.parse(JSON.stringify(this.props.item)),
        defaultChecked = (this.props.selections[tag.ChildNumber] != null),
        disabled = tag.Status !== 'Available' ? 'disabled' : '',
        label = 'Child #' + tag.ChildNumber + ' - ' + tag.Gender + ' - ' + tag.AgeText + ' old';
    return (
    <div><label><input type="checkbox" onChange={this.handleCheck} defaultChecked={defaultChecked} disabled={disabled}></input> {label} {disabled ? <em>(already taken)</em> : ''}</label></div>
    );
  }
}

export default TagSelector;
